module.exports = __webpack_public_path__ + "img/icon_1_48.0ea6aa39.png";